import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { selectGlobalIndustryCodesListItems } from "../../../../../redux/global-iship-cloud/global-industry-codes/selector";
import { globalIndustryCodes } from "../../../../../redux/global-iship-cloud/global-industry-codes/action";

const GlobalIndustryCodes = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const globalIndustryListItems = useSelector(selectGlobalIndustryCodesListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name', searchField: 'Name', filter: true, filterType: 'text' },
            { field: 'Code', headerName: 'Code', searchField: 'Code', filter: true, filterType: 'text' },
        ]);
    }

    const fetchGlobalIndustryCodesList = async () => {
        await dispatch(globalIndustryCodes.resetAction({ actionType: 'list' }))
        await dispatch(globalIndustryCodes.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-industry-codes/fetch`,
            entity: 'globalIndustryCodes',
            jsonData:
            {
                Context: {},
                Records: [{}],
                Pagination: {
                    PageNumber: pageData,
                    PageSize: pageSize,
                    SortField: "Id",
                    SortOrder: "desc",
                }
            }
        }))
    }

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.GlobalHSCodeId}`)
    }

    useEffect(() => {
        createColumnDefs();
        fetchGlobalIndustryCodesList();
    }, [pageData, pageSize])

    const additionButtons: any = [

        // {
        //     svg:
        //         <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
        //             <title>Add Loops</title>
        //             <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        //         </svg>,
        //     callback: () => handleAdd(),
        // },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload</title>
                    <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleReloadData = () => {
        fetchGlobalIndustryCodesList();
    }



    const handleDelete = async (data: any) => {
        await dispatch(globalIndustryCodes.resetAction({ actionType: 'delete' }))
        await dispatch(globalIndustryCodes.delete({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-industry-codes/delete`,
            entity: 'globalIndustryCodes',
            jsonData:
            {
                Context: {},
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        }))
        await fetchGlobalIndustryCodesList();

    }




    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column || data?.searchCriteriaList,
                FieldText: data?.column || data?.searchCriteriaList,
                FieldType: 'text',
                FilterOperatorId: data?.filterOperatorId || 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(globalIndustryCodes.resetAction({ actionType: 'list' }))
        await dispatch(globalIndustryCodes.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-industry-codes/fetch`,
            entity: 'globalIndustryCodes',
            jsonData: {
                Context: {},
                Records: [{}],
                Pagination: {
                    PageNumber: pageData,
                    PageSize: pageSize,
                    SortField: "Id",
                    SortOrder: "desc",
                    Searches: searchCriteria,
                },
            }
        }))
    }



    return (
        <>

            {globalIndustryListItems?.isLoading ? <PageLoader /> :
                <Table
                    columnData={columnDefs}
                    rowData={globalIndustryListItems?.result?.items}
                    setPageData={setPageData} setPageSize={setPageSize}
                    paginationData={globalIndustryListItems?.result?.pagination}
                    enableFilter={true}
                    onSearch={handleSearch}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'Id',
                    }}
                    onDelete={handleDelete} additionButtons={additionButtons}
                    headingName="Global Industry Codes"
                />
            }
        </>
    );
};

export default GlobalIndustryCodes;


